import { action, makeObservable, observable } from 'mobx';

const MAX_ENTRIES = 30;

export type RestorableListState = Record<string, string | number | boolean | undefined | string[] | number[]>;

type RestoreEntry = {
  state: RestorableListState;
  updatedAt: number;
};

export default class ListRestoreStore {
  entries = new Map<string, RestoreEntry>();
  pendingRestorePathname: string | null = null;

  constructor() {
    makeObservable(this, {
      entries: observable,
      pendingRestorePathname: observable,
      setState: action,
      clearState: action,
      clearAll: action,
      signalRestore: action,
      consumeRestore: action,
    });
  }

  signalRestore(pathname: string): void {
    this.pendingRestorePathname = pathname;
  }

  consumeRestore(pathname: string): boolean {
    if (this.pendingRestorePathname === pathname) {
      this.pendingRestorePathname = null;
      return true;
    }
    return false;
  }

  getState(key: string): RestorableListState | undefined {
    return this.entries.get(key)?.state;
  }

  setState(key: string, state: RestorableListState): void {
    if (!this.entries.has(key) && this.entries.size >= MAX_ENTRIES) {
      let oldestKey: string | undefined;
      let oldestTime = Infinity;
      this.entries.forEach((entry, k) => {
        if (entry.updatedAt < oldestTime) {
          oldestTime = entry.updatedAt;
          oldestKey = k;
        }
      });
      if (oldestKey) {
        this.entries.delete(oldestKey);
      }
    }

    this.entries.set(key, { state, updatedAt: Date.now() });
  }

  clearState(key: string): void {
    this.entries.delete(key);
  }

  clearAll(): void {
    this.entries.clear();
    this.pendingRestorePathname = null;
  }
}
